import { Serializable } from '../base';

export class JuspayTransaction implements Serializable<JuspayTransaction> {
    public url: string;
    public method: string;
    public params: any;
    public amount: number;
    public status: string;
    public expiry: string;
    public order_expiry: string;

    private client_auth_token: string;
    private client_auth_token_expiry: string;
    private txn_id: string;
    private order_id: string;
    private customer_id: string;
    private customer_email: string;
    private customer_phone: string;

    // Nested fields within sdk_payload
    private request_id: string;
    public service: string;
    public currency: string;
    public environment: string;
    public description: string;
    public merchant_id: string;
    private return_url: string;
    private collect_avs_info: boolean;

    // Payment Links
    private payment_links_web: string;

    get transactionId() { return this.txn_id }
    get orderId() { return this.order_id }

    get customerId() { return this.customer_id }
    get customerEmail() { return this.customer_email }
    get customerPhoneNumber() { return this.customer_phone }

    get clientAuthToken(): string {
      return this.client_auth_token;
    }

    get clientAuthTokenExpiry(): string {
      return this.client_auth_token_expiry;
    }

    get returnUrl(): string {
      return this.return_url;
    }

    get paymentLinkWeb(): string {
      return this.payment_links_web;
    }

    get requestId(): string {
      return this.request_id;
    }

    get collectAvsInfo(): boolean {
      return this.collect_avs_info;
    }

    constructor() { }

    deserialize(input) {
        this.url = input.url;
        this.status = input.status;
        this.order_id = input.order_id;
        this.expiry = input.payment_links.expiry;
        this.order_expiry = input.order_expiry;
        this.payment_links_web = input.payment_links.web;

        // sdk_payload mapping
        const sdkPayload = input.sdk_payload;
        this.request_id = sdkPayload.requestId;
        this.service = sdkPayload.service;
        const payload = sdkPayload.payload;
        this.amount = parseFloat(payload.amount);
        this.client_auth_token = payload.clientAuthToken;
        this.client_auth_token_expiry = payload.clientAuthTokenExpiry;
        this.customer_email = payload.customerEmail;
        this.customer_id = payload.customerId;
        this.customer_phone = payload.customerPhone;
        this.currency = payload.currency;
        this.environment = payload.environment;
        this.description = payload.description;
        this.merchant_id = payload.merchantId;
        this.return_url = payload.returnUrl;
        this.collect_avs_info = payload.collectAvsInfo;

        return this;
    }
}
